import React, { useState, useEffect } from 'react';
import { Users } from 'lucide-react';

const SocialProofToast = () => {
  const [visible, setVisible] = useState(false);
  const [count, setCount] = useState(0);

  useEffect(() => {
    // Show after 10 seconds
    const showTimer = setTimeout(() => {
      const base = new Date().getHours() < 12 ? 2 : new Date().getHours() < 18 ? 5 : 3;
      setCount(base + Math.floor(Math.random() * 3));
      setVisible(true);
    }, 10000);

    return () => clearTimeout(showTimer);
  }, []);

  useEffect(() => {
    if (!visible) return;
    // Auto-hide after 8 seconds
    const hideTimer = setTimeout(() => setVisible(false), 8000);
    return () => clearTimeout(hideTimer);
  }, [visible]);

  if (!visible) return null;

  return (
    <div
      data-testid="social-proof-toast"
      className="fixed bottom-20 lg:bottom-24 left-4 z-30 animate-fade-up"
    >
      <div className="bg-white rounded-xl shadow-2xl px-4 py-3 flex items-center gap-3 border border-gray-100 max-w-xs">
        <div className="w-8 h-8 rounded-full bg-gold/10 flex items-center justify-center flex-shrink-0">
          <Users className="w-4 h-4 text-gold" />
        </div>
        <div>
          <p className="text-gray-900 text-sm font-semibold">{count} couples checked their date today</p>
          <p className="text-gray-400 text-xs">Popular dates are going fast</p>
        </div>
      </div>
    </div>
  );
};

export default SocialProofToast;
